import { SITE_URL, getAbsoluteSiteUrl } from '@/data/blogSeoMetadata';

export { SITE_URL, getAbsoluteSiteUrl };

export const BIOMARKER_PAGE_PATH = '/platform/biomarker-informed-nutrition';
export const BIOMARKER_PAGE_CANONICAL_URL = getAbsoluteSiteUrl(BIOMARKER_PAGE_PATH);

export const BIOMARKER_PAGE_TITLE = 'Biomarker Nutrition Platform for UK Practitioners | CalorieScience';

export const BIOMARKER_META_DESCRIPTION =
  'Turn lab reports into structured nutrition insights and practitioner-reviewed plans. CalorieScience connects biomarkers, diet and client context in one workflow.';

export const BIOMARKER_PRIMARY_KEYWORD = 'biomarker nutrition platform';

export type BiomarkerFaq = {
  question: string;
  answer: string;
};

export const BIOMARKER_FAQS: BiomarkerFaq[] = [
  {
    question: 'What is a biomarker nutrition platform?',
    answer:
      'A biomarker nutrition platform helps nutrition professionals organise laboratory information and use it alongside dietary assessment and the wider client context when creating nutrition plans.',
  },
  {
    question: 'Can I upload a client blood report?',
    answer:
      'Yes. CalorieScience supports blood report upload and extracts supported biomarker values into the client record for practitioner review.',
  },
  {
    question: 'How are biomarkers used in the meal plan?',
    answer:
      'Supported biomarker information is considered alongside the client profile, dietary intake, symptoms, goals and preferences when CalorieScience generates an AI-assisted meal plan. The practitioner reviews and approves the final plan.',
  },
  {
    question: 'Does CalorieScience diagnose conditions?',
    answer:
      'No. CalorieScience supports nutrition workflow and practitioner review. It does not diagnose a condition, prescribe treatment or replace medical assessment.',
  },
  {
    question: 'Does AI replace the practitioner?',
    answer:
      'No. The practitioner decides what is relevant, edits the plan and approves the final recommendation.',
  },
  {
    question: 'How does CalorieScience support UK and European practices?',
    answer:
      'CalorieScience is designed for UK and European nutrition professionals, with systems and processes built to meet UK and EU GDPR requirements for handling sensitive client information.',
  },
];
